import { lazy } from "react";
import type { RouteObject } from "react-router";

const DashboardPage = lazy(() => import("./views/dashboard"));

const directInvestments: RouteObject = {
  id: "direct-investments",
  path: "/direct-investments",
  element: <DashboardPage />,
};

export default directInvestments;
